import styled from 'styled-components';

import { HOME } from '../../../../theme/tokens';
import { Text } from '../../../../components';

export const Root = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const LabelRow = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`;

export const Lbl = styled(Text)`
  font-size: 16px;
  color: ${HOME.t300};
`;

export const PVal = styled.div`
  font-size: 24px;
  font-weight: 700;
  line-height: 1.1;
  color: ${HOME.t50};
`;

export const DeltaRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 8px;
  flex-wrap: wrap;
  row-gap: 4px;
`;

export const Sub = styled(Text)`
  font-size: 13px;
  font-weight: 400;
  color: ${HOME.t600};
  white-space: nowrap;
`;
